import { getShipperScopeUids } from "../shipper/applyShipperScopeParams";

export const VEHICLE_LIST_LIMIT = 100;

export const EMPTY_VEHICLE_FILTERS = {
  vehiclePlate: "",
  descricaoVeiculo: "",
  vehicleType: "",
  ufVeiculo: "",
};

export const VEHICLE_FILTER_FIELDS = Object.keys(EMPTY_VEHICLE_FILTERS);

/**
 * Monta query params de listagem (escopo + filtros ativos).
 * Retorna null quando o usuário não tem escopo válido (lista vazia).
 */
export function buildVehicleListParams(user, filters = EMPTY_VEHICLE_FILTERS) {
  const params = {
    page: 1,
    limit: VEHICLE_LIST_LIMIT,
  };

  const allowedUids = getShipperScopeUids(user);

  if (allowedUids === null) {
    params.viewAll = "true";
  } else if (allowedUids.length === 0) {
    return null;
  } else {
    applyShipperParams(params, user, allowedUids);
  }

  applyActiveFilters(params, filters);
  return params;
}

function applyShipperParams(params, user, allowedUids) {
  if (user.uidShipper) {
    params.uidShipper = user.uidShipper;
  }
  if (
    Array.isArray(user.uidShipperAffiliates) &&
    user.uidShipperAffiliates.length
  ) {
    params.affiliates = user.uidShipperAffiliates.join(",");
  }
  if (!params.uidShipper && allowedUids.length > 0) {
    params.uidShipper = allowedUids[0];
    if (allowedUids.length > 1) {
      params.affiliates = allowedUids.slice(1).join(",");
    }
  }
}

function applyActiveFilters(params, filters) {
  for (const field of VEHICLE_FILTER_FIELDS) {
    const value = String(filters[field] ?? "").trim();
    if (value) {
      params[field] = value;
    }
  }
}

export function unwrapVehicleListItems(response) {
  const payload = response?.data;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
}

export function toCreatedAtSeconds(value) {
  if (!value) return 0;
  if (typeof value?.seconds === "number") return value.seconds;
  if (typeof value?._seconds === "number") return value._seconds;
  if (typeof value === "string") {
    const ms = Date.parse(value);
    return Number.isNaN(ms) ? 0 : ms / 1000;
  }
  return 0;
}

export function sortVehiclesByCreatedAtDesc(items) {
  return [...items].sort(
    (a, b) => toCreatedAtSeconds(b?.createdAt) - toCreatedAtSeconds(a?.createdAt),
  );
}

/** Valor controlado do input da lupa (evita reset ao apagar). */
export function resolveFilterInputValue(selectedKeys, activeFilter) {
  return selectedKeys[0] !== undefined ? selectedKeys[0] : activeFilter ?? "";
}

/** Keys enviadas ao buscar (dropdown ou filtro já aplicado). */
export function resolveFilterSearchKeys(selectedKeys, activeFilter) {
  if (selectedKeys[0] !== undefined) return selectedKeys;
  return activeFilter ? [activeFilter] : [""];
}

export function canViewVehicle(user) {
  return Boolean(
    user?.permissoes?.vehicle?.isView || user?.permissoes?.veiculo?.visualizar,
  );
}

export function canEditVehicle(user) {
  return Boolean(
    user?.permissoes?.vehicle?.isEdit || user?.permissoes?.veiculo?.editar,
  );
}

export function canDeleteVehicle(user) {
  return Boolean(
    user?.permissoes?.vehicle?.isDelete || user?.permissoes?.veiculo?.excluir,
  );
}

export function canCreateVehicle(user) {
  return Boolean(
    user?.permissoes?.vehicle?.isCreate || user?.permissoes?.veiculo?.cadastrar,
  );
}

export function compareText(a, b) {
  return String(a || "").localeCompare(String(b || ""));
}
